import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NotFound = () => (
  <div className="h-screen flex items-center -mt-10">
    <div className="w-full flex flex-col items-center gap-6">
      <FontAwesomeIcon icon="robot" className="text-6xl" />

      <div className="uppercase font-mono tracking-tighter">
        Página não encontrada
      </div>

      <a
        className="border rounded py-2 px-4 font-bold hover:bg-slate-50 flex gap-2 items-center"
        href="/"
      >
        <FontAwesomeIcon icon="house" />
        <span>Voltar para o início</span>
      </a>
    </div>
  </div>
);

export default NotFound;
